import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5a9fff0c&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9fff0c')) {
      api.createRecord('5a9fff0c', component.options)
    } else {
      api.reload('5a9fff0c', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=5a9fff0c&", function () {
      api.rerender('5a9fff0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/fast-tracking/Search.vue"
export default component.exports